import React, { useEffect, useState } from 'react';
import { PhotoView } from 'react-photo-view';

import { Space, Spin, Typography, message, theme } from 'antd';

import Configurazione from '../../Configurazione';
import { GetErrorMessage } from '../../Utility';
import '../Magazzino.css';

type BloccoLastraModel = {
    codCliente: string;
    numeroBlocco: string;
    numeroBloccoFornitore: string;
    monolama: string;
    qualita: string;
    finitura: string;
    lun: number;
    lar: number;
    spessore: number;
    numeroLastra: number;
    pezzi: number;
    nomefile: string;
    isCliente: boolean;
    um: string;
};

export default function BloccoLastraCardMagCli(item: BloccoLastraModel) {
    const { token } = theme.useToken();

    const [isRunning, setIsRunning] = useState(false);
    const [img, setImg] = useState('');
    useEffect(() => {
        GetImg();
    }, [item]);

    async function GetImg() {
        try {
            setIsRunning(true);

            if (item.nomefile === null) {
                setImg(GetNoFoto);
                return;
            }
            const res = await fetch(
                Configurazione().apiBaseUrl + 'Magazzino/GetFoto?fotoNome=' + item.nomefile + '&tipo=3'
            );

            if (res.status === 200) {
                const imageBlob = await res.blob();
                const imageObjectURL = URL.createObjectURL(imageBlob);

                if (imageObjectURL) setImg(imageObjectURL);
                else setImg(GetNoFoto);
            } else setImg(GetNoFoto);
        } catch (error) {
            message.error(GetErrorMessage(error));
        } finally {
            setIsRunning(false);
        }
    }

    function GetNoFoto(): string {
        if (item.um === 'TO') return '../custom/no-imageblocchi_300.png';
        else return '../custom/no-imagelastre_300.png';
    }

    return (
        <PhotoView src={Configurazione().apiBaseUrl + 'Magazzino/GetFoto?fotoNome=' + item.nomefile + '&tipo=2'}>
            <div style={{ margin: '10px', marginBottom: '20px' }}>
                <Spin spinning={isRunning}>
                    <img
                        alt=""
                        className="imagegallery"
                        src={img}
                        style={{ cursor: 'pointer' }}
                        onError={(event) => (event.currentTarget.src = GetNoFoto())}
                    ></img>
                </Spin>

                <div>
                    <Space direction="vertical">
                        <Typography.Text>
                            <span style={{ color: token.colorPrimary }}>{item.qualita}</span>- Int. {item.numeroBlocco}{' '}
                            - Bl.{item.numeroBloccoFornitore} {item.monolama}
                            {item.numeroLastra === 0 ? '' : '- Lastra N° ' + item.numeroLastra} - {item.finitura}
                        </Typography.Text>
                        <Typography.Text>
                            <span>Lun {item.lun} cm</span> - Lar {item.lar} cm - Sp/Alt {item.spessore} cm
                        </Typography.Text>
                    </Space>
                </div>
            </div>
        </PhotoView>
    );
}
